import { render, staticRenderFns } from "./agent-mode-setting.dialog.vue?vue&type=template&id=bc7559c6&scoped=true"
import script from "./agent-mode-setting.dialog.vue?vue&type=script&lang=js"
export * from "./agent-mode-setting.dialog.vue?vue&type=script&lang=js"
import style0 from "./agent-mode-setting.dialog.vue?vue&type=style&index=0&id=bc7559c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7559c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc7559c6')) {
      api.createRecord('bc7559c6', component.options)
    } else {
      api.reload('bc7559c6', component.options)
    }
    module.hot.accept("./agent-mode-setting.dialog.vue?vue&type=template&id=bc7559c6&scoped=true", function () {
      api.rerender('bc7559c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/agent/components/agent-mode-setting.dialog.vue"
export default component.exports